import { Company } from '../../../types/company/Company'

export interface ReconciliationQueryParams {
  groupCompanyId?: Company['id']
}

const reconciliationQueryKeys = {
  all: [{ scope: 'icReconciliation' }] as const,
  lists: () => [{ ...reconciliationQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: ReconciliationQueryParams) => [{ ...reconciliationQueryKeys.lists()[0], ...params }] as const
}

export default reconciliationQueryKeys
